module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-4-526b82ff39fb9ba33b9928eb2d7721cc.png";